/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { ILaborReviewState } from 'store/types';
import { ILabor } from 'types';
import { LaborReview } from './types';

const initialState: ILaborReviewState = { labor: null, posJobTitles: null };

export const laborReviewReducer: Reducer<ILaborReviewState> = (state = initialState, action) => {
  switch (action.type) {
    // Cleared while loading and on failure, so another business day's records (and their versions) are never
    // shown or saved against this one.
    case LaborReview.GET_LABOR_REQUEST:
    case LaborReview.GET_LABOR_FAIL: {
      return { ...state, labor: null };
    }
    case LaborReview.GET_LABOR_SUCCESS: {
      return { ...state, labor: action.payload };
    }
    // Cleared while loading and on failure, so another site's job titles are never offered for this one.
    case LaborReview.GET_POS_JOB_TITLES_REQUEST:
    case LaborReview.GET_POS_JOB_TITLES_FAIL: {
      return { ...state, posJobTitles: null };
    }
    case LaborReview.GET_POS_JOB_TITLES_SUCCESS: {
      return { ...state, posJobTitles: action.payload };
    }
    case LaborReview.UPDATE_LABOR_SUCCESS:
    case LaborReview.RESTORE_LABOR_SUCCESS: {
      if (!state.labor) return state;
      const response = action.payload as ILabor;
      // An employee can have a record at each of the site's locations, so a record is matched on both. Saving labor for an
      // employee with no record at that location creates one, so it's added rather than replaced.
      const isResponseRecord = (labor: ILabor) => labor.locationId === response.locationId && labor.employeeId === response.employeeId;
      const hasRecord = state.labor.data.some(isResponseRecord);
      const data = hasRecord ? state.labor.data.map((labor) => (isResponseRecord(labor) ? response : labor)) : [...state.labor.data, response];
      return { ...state, labor: { ...state.labor, data } };
    }
    default: {
      return state;
    }
  }
};
